import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { AuthService } from '../shared/services/auth.service';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class MaterialsService {

  constructor(
    private _http:Http,
    private _authService:AuthService
  ) { }

  getMaterials() {
    const url = `${environment.apiUrl}materials/all`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.get(url, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  addMat(mat) {
    const url = `${environment.apiUrl}materials/add`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {material:mat}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  addColor(mat, color) {
    const url = `${environment.apiUrl}colors/add`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {material:mat, color:color}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  delMat(mat) {
    const url = `${environment.apiUrl}materials/delete`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {material:mat}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

  delColor(mat, color) {
    const url = `${environment.apiUrl}colors/delete`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {material:mat, color:color}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw(error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/materials/materials.service.ts